import { Box, InputBase, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import EyeClosedIcon from "../../assets/SVG/eyeClosedIcon";
import EyeOpenIcon from "../../assets/SVG/eyeOpenIcon";
import ProfileIcon from "../../assets/SVG/profileIcon";

export default function InputLoginForm({
  placeholder,
  lable,
  children,
  mt,
  password,
  width,
  value,
  main,
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [value1, setValue1] = useState();
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  //   useEffect(()=>{
  // if({...props.value}){

  //   setValue1({...props.value})

  // }
  //   },[{...props.value}])
  // console.log(value);
  return (
    <Box>
      <Typography
        sx={{
          color: "#2B2B2B",
          textAlign: "right",
          fontFamily: "Raleway",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "150%",
          my: "8px",
          mt: mt ? mt : "8px",
          display: "flex",
        }}
      >
        {lable}
        {main && (
          <Typography color="red" mr="5px">
            *
          </Typography>
        )}
      </Typography>
      <Box
        boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.08)"
        border="solid 1px #D7D7D7"
        gap="20px"
        padding="8px 24px"
        width={width ? width : "380px"}
        borderRadius="8px"
        display="flex"
        alignItems="center"
      >
        {children}
        {!password && (
          <InputBase
            sx={{
              "&.MuiInputBase-root ": {
                width: "75% !important",
              },
            }}
            {...props}
            placeholder={placeholder}
            value={value}
          />
        )}
        {password && (
          <InputBase
            sx={{
              "&.MuiInputBase-root ": {
                width: "75% !important",
              },
            }}
            value={value}
            type={showPassword ? "text" : "password"}
            {...props}
            placeholder={placeholder}
          />
        )}
        {password && value && (
          <Box sx={{ cursor: "pointer" }} onClick={handleClickShowPassword}>
            {showPassword ? <EyeOpenIcon /> : <EyeClosedIcon />}
          </Box>
        )}
      </Box>
    </Box>
  );
}
